import { isPermissionCheckedAppMediaUrl } from '../../../element/image/imageUtils';

/**
 * Fetch the image pixel data from the image
 *
 * @param {string} url
 */
const fetchImageData = (url) =>
    // FIXME Move function off the client so can be performed for all images,
    // without load on client or facing client compatibility issues
    new Promise((resolve, reject) => {
        const image = new Image();

        // Reading pixels back out of the canvas throws unless a cross-origin image was loaded in CORS
        // mode, so cross-origin sources have to opt in.
        //
        // `Anonymous` sends no cookies, which is what public media wants but which permission-checked
        // app media answers with a 403 — it authorises from the session cookie. `use-credentials` sends
        // it and keeps the canvas clean, given the media CDN returns an exact allowed origin plus
        // `Access-Control-Allow-Credentials` (see infra SecureMediaResponseHeadersPolicy).
        //
        // On web this branch is skipped for app media entirely, since it is served same-origin.
        if (!url.startsWith(window.location.origin)) {
            image.crossOrigin = isPermissionCheckedAppMediaUrl(url) ? 'use-credentials' : 'Anonymous';
        }

        image.onload = () => {
            const canvas = document.createElement('canvas');

            canvas.width = image.width;
            canvas.height = image.height;

            const context = canvas.getContext('2d');
            context.drawImage(image, 0, 0);

            const pixels = context.getImageData(0, 0, image.width, image.height);
            resolve(pixels);
        };

        image.onerror = (err) => reject(err);

        image.src = url;
    });

export default fetchImageData;
